import TicketService from '_services/rest/modules/ticket';

export default {
  state: {
    ticketList: null,
    ticketEdit: null,
  },
  mutations: {
    setTicket(state, response) {
      state.ticketEdit = response;
    },
    setTicketList(state, response) {
      state.ticketList = response;
    },
  },
  actions: {
    getTicketList({ commit }, params) {
      return TicketService.getList(params)
        .then(response => {
          commit('setTicketList', response);
        });
    },

    getTicket({ commit }, params) {
      return TicketService.getTicketById(params)
        .then(response => {
          commit('setTicket', response);
          return response;
        });
    },

    updateTicket({ commit }, params) {
      return TicketService.updateTicket(params)
        .then(response => {
          commit('setTicket', response);
          return response;
        });
    },
  },
};
